
import React from 'react';

export const PianoIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M20 2H4C2.9 2 2 2.9 2 4v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8.5 16h-2V4h2v12zm3.5 0h-2V4h2v12zm3.5 0h-2V4h2v12z"/>
    <path d="M9.5 4h-1v8h1V4zm4 0h-1v8h1V4z" />
  </svg>
);
